var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details col-xs-9 col-sm-10" }, [
    _c(
      "div",
      { staticClass: "details-wrapper" },
      [
        _vm.modulo === "booking"
          ? _c("sdr-shared-fsr-flight-firstrow-booking", {
              attrs: {
                flight: _vm.flight,
                flightdirection: _vm.flightdirection,
                modulo: _vm.modulo,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "services"
          ? _c("sdr-shared-fsr-flight-firstrow-services", {
              attrs: {
                flight: _vm.flight,
                flightdirection: _vm.flightdirection,
                modulo: _vm.modulo,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "booking"
          ? _c("sdr-shared-fsr-flight-secondrow-booking", {
              attrs: {
                flight: _vm.flight,
                flightdirection: _vm.flightdirection,
                modulo: _vm.modulo,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "services"
          ? _c("sdr-shared-fsr-flight-secondrow-services", {
              attrs: {
                flight: _vm.flight,
                flightdirection: _vm.flightdirection,
                modulo: _vm.modulo,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.modulo === "booking" &&
    _vm.flight.prcs[0] !== undefined &&
    _vm.flight.warn === ""
      ? _c(
          "div",
          { staticClass: "row", staticStyle: { "margin-bottom": "0px" } },
          [
            _c("sdr-shared-fsr-flight-taxesandfees", {
              attrs: {
                flight: _vm.flight,
                flightdirection: _vm.flightdirection,
                modulo: _vm.modulo,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }